// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if ({"node_modules_tw-elements_dist_js_chart_es_js":1,"node_modules_tw-elements_dist_js_chartjs-plugin-datalabels_es_js":1}[chunkId]) return "javascript/dist/" + chunkId + ".js";
	// return url for filenames based on template
	return undefined;
};